<template>
  <div id="index" class="contenido-oficina">
    <div class="w-100" style="height: var(--safe-area-inset-top)" v-if="asWideScreenMenu"></div>
    <div class="flex-column text-center fg-white">
      <div>
        <img src="@/assets/images/logos/koinonia10.webp" alt="" style="max-width: 90%">
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'koinonia10-cronologia-general'})">
        Red Social
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'herramientas-compra'})">
        Obtener Saldo Koinonía10
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'koinonia10-saldo'})">
        Saldo Koinonía10
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'koinonia10-influencer'})">
        Influencer
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'spots-lista-0'})">
        Anunciantes
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'koinonia10-beneficios-saldo'})">
        Beneficios
      </div>
      <div class="mx-4 mt-5 shadow-1 border-radius-10 h4 text-bold py-3 px-1 options-gradient c-pointer"
           @click="safeRoutePush({name: 'miembros-f'})">
        <span>Beneficios de patrocinadores</span><br>
        <span style="font-size: 1rem">F4 y F3</span>
      </div>
      <div class="mx-4 mt-5" v-if="asWideScreenMenu" id="switch-menu">
        <img class="border border-radius-20 bd-orange border-size-2 p-2 c-pointer w-50"
             src="@/assets/images/logos/virtual-shopping-club.webp" alt="" @click="$emit('switch-menu')">
      </div>
    </div>
    <div class="mt-10 mx-2 mb-2">
      <div class="text-small border border-radius-10 c-pointer text-center bd-lightBlue fg-darkBlue p-1"
           @click="safeRoutePush({name: 'help', params: {slug: 'terminos-y-condiciones-koinonia10'}})">
        <i class="fa-brands fa-readme mr-1"></i><span>Términos y Condiciones</span>
      </div>
    </div>
  </div>
</template>

<script>
import terminosCondiciones from "@/components/fondos/terminos-condiciones.vue"

export default {
  name: "index",
  props: {
    asWideScreenMenu: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    if (!this.asWideScreenMenu) {
      this.$store.commit('SET_NAVBAR_FG_COLOR', {'fg-white': true})
    }
  },
  mounted() {
    if (!this.asWideScreenMenu) {
      this.$store.commit('SET_SHOW_MENU', {show_menu: false, path: null})
      this.$store.commit('SET_TITLE_MENU', '')
      this.$store.commit('SET_NAVBAR_FG_COLOR', {'fg-red': true})
    }
  },
  methods: {
    showTerminos() {
      this.$store.commit('PUSH_TO_FULL_MODAL_POSITIONS', window.scrollY)
      this.$FModal.show(
        {
          component: terminosCondiciones,
          overlayStyles: {
            backgroundColor: 'rgba(12, 52, 161, 0.27)'
          },
          clickToClose: true,
        },
        {
          documentoSlug: 'terminos-y-condiciones-koinonia10'
        }
      )
    },
    safeRoutePush(route) {
      let differentRoute = this.$route.name !== route.name
      if (!differentRoute) {
        //Comparar params
        const keysParamsDest = route.params ? Object.keys(route.params) : []
        const keysParamsSrc = Object.keys(this.$route.params)
        differentRoute = keysParamsDest.length !== keysParamsSrc.length
        if (!differentRoute && keysParamsDest.length > 0) {
          const uniqueKeys = [...new Set(keysParamsDest.concat(keysParamsSrc))]
          for (const key of uniqueKeys) {
            differentRoute = this.$route.params[key] !== route.params[key]
            if (differentRoute) {
              break
            }
          }
        }
      }
      if (differentRoute) {
        this.$router.push(route).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.options-gradient {
  background: #237ca6;
  background: linear-gradient(135deg,rgba(35, 124, 166, 1) 0%, rgba(0, 174, 255, 1) 100%);
}
@media (min-width: 1236px) {
  #switch-menu {
    display: none;
  }
}
</style>